import * as actions from './actions';
import { Campaign } from './../components/manager-home/model/CampaignModel';
export const initialState: Campaign = {};

export function reducer(state = initialState, action: actions.ManagerHomeActions) {
  switch (action.type) {
    case actions.ManagerHomeActionTypes.SELECT_CAMPAIGN:
      return state = action.payload.campaign;
    default:
      return state;
  }

}
